import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { Observer } from 'gsap/Observer';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import imagesLoaded from 'imagesloaded';
import barba from '@barba/core';
import { smoothPause, smoothGoTo  } from "../parts/lenis";

export function nove() {
    if (jQuery(".intro-grid").length == 0) {
        return;
    }   
    gsap.config({
        nullTargetWarn: false,
    });

    gsap.registerPlugin(Flip);
    gsap.registerPlugin(Observer);

    const preloadImages = (selector = "img") => {
        return new Promise((resolve) => {
            imagesLoaded(
                document.querySelectorAll(selector),
                { background: true },
                resolve
            );
        });
    };

    const introGrid = document.querySelector(".intro-grid--images");
    const gridImages = [...introGrid.querySelectorAll(".intro-grid__img")];

    gridImages.forEach((image) => {
        var colorsArray = image.dataset.colors.split(", ");
        var imageArray = image.dataset.images.split(", ");
        
        const colorsContainer = document.createElement("div");
        colorsContainer.classList.add("colors-container");
        image.appendChild(colorsContainer);

        colorsArray.forEach((color, index) => {
            var img = imageArray[index];
            colorsContainer.insertAdjacentHTML(
                "beforeend",
                `<div class="colors-box" style="background-color: ${color}; background-image: url(${img})"></div>`
            );
        });
    });

    const gridTitle = {
        main: document.querySelector(
            ".intro-title > .intro-title__main > .oh__inner"
        ),
        sub: document.querySelector(
            ".intro-title > .intro-title__sub > .oh__inner"
        ),
    };
    const sliderTitle = {
        el: document.querySelector(".slider-title"),
        main: document.querySelector(
            ".slider-title > .slider-title__main > .oh__inner"
        ),
        desc: document.querySelector(".slider-title > .slider-title__desc"),
    };

    function shuffle(array) {
        const arr = [...array];
        let currentIndex = array.length,
            randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex > 0) {
            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [arr[currentIndex], arr[randomIndex]] = [
                arr[randomIndex],
                arr[currentIndex],
            ];
        }
        return arr;
    }

    const controls = document.querySelector(".controls");
    const closeCtrl = controls.querySelector("button.close");
    const nav = controls.querySelector("nav.nav");

    const slideTextTitle = document.querySelector(
        ".slider-title__main.oh .oh__inner"
    );
    const slideTextContent = document.querySelector(".slider-title__desc");

    // grid || slider
    let mode = "grid";
    let current = -1;
    let isAnimating = false;

    const arr = Array(24)
        .fill("")
        .map((_, i) => i + 1);
    const shuffledGrid = shuffle(arr)
        .slice(0, gridImages.length)
        .sort((a, b) => a - b);

    gridImages.forEach((image, i) => {
        image.classList.add(`pos-${shuffledGrid[i]}`);
        introGrid.appendChild(image);
    });

    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
        arr.forEach((n) => {
            if (n <= 6 && !shuffledGrid.includes(n + 6)) {
                gsap.set(`.pos-${n}`, {
                    yPercent: gsap.utils.random(18, 25),
                });
            }
        });
        arr.forEach((n) => {
            if (n > 6 && n <= 12 && !shuffledGrid.includes(n + 6)) {
                gsap.set(`.pos-${n}`, {
                    yPercent: gsap.utils.random(4, 8),
                });
            }
        });
        arr.forEach((n) => {
            if (n > 12 && n <= 18 && !shuffledGrid.includes(n + 6)) {
                gsap.set(`.pos-${n}`, {
                    yPercent: gsap.utils.random(4, 8),
                });
            }
        });
        arr.forEach((n) => {
            if (n > 18 && n <= 24 && shuffledGrid.includes(n - 6)) {
                gsap.set(`.pos-${n}`, {
                    yPercent: gsap.utils.random(8, 14),
                });
            }
        });
    });

    mm.add("(max-width: 767px)", () => {
        gsap.set(gridImages, {
            yPercent: 0,
            xPercent: 0,
        });
    });

    const breakGrid = () => {
        isAnimating = true;
        mm.add("(min-width: 768px)", () => {
            arr.forEach((n) => {
                if (n <= 6 && !shuffledGrid.includes(n + 6)) {
                    gsap.to(`.pos-${n}`, {
                        yPercent: gsap.utils.random(18, 25),
                        ease: "power1.in",
                        duration: 0.5,
                    });
                }
            });
            arr.forEach((n) => {
                if (n > 6 && n <= 12 && !shuffledGrid.includes(n + 6)) {
                    gsap.to(`.pos-${n}`, {
                        yPercent: gsap.utils.random(4, 8),
                        ease: "power1.in",
                        duration: 0.5,
                        onComplete: () => {
                            isAnimating = false;
                        },
                    });
                }
            });
            arr.forEach((n) => {
                if (n > 12 && n <= 18 && !shuffledGrid.includes(n + 6)) {
                    gsap.to(`.pos-${n}`, {
                        yPercent: gsap.utils.random(4, 8),
                        ease: "power1.in",
                        duration: 0.5,
                    });
                }
            });
            arr.forEach((n) => {
                if (n > 18 && n <= 24 && shuffledGrid.includes(n - 6)) {
                    gsap.to(`.pos-${n}`, {
                        yPercent: gsap.utils.random(8, 14),
                        ease: "power1.in",
                        duration: 1,
                    });
                }
            });
        });
    };

    const lineUpGrid = () => {
        isAnimating = true;
        gsap.to(gridImages, {
            yPercent: 0,
            onComplete: () => {
                isAnimating = false;
            },
        });
    };

    gsap.to(gridImages, {
        duration: 3,
        opacity: 1,
        stagger: 0.1,
        delay: 0.5,
        ease: "power4",
    });

    // Show the slider
    const showSlider = (image) => {
        if (isAnimating || mode === "slider") {
            goToCollection(image);
            return;
        }
        isAnimating = true;
        mode = "slider";

        const DURATION = 1;
        const EASE = "power4.inOut";
        smoothGoTo(0, false);
        smoothPause(true)       
        current = gridImages.indexOf(image);
        const currentImage = gridImages[current];
        slideTextTitle.innerText = currentImage.dataset.title;
        slideTextContent.innerText = currentImage.dataset.text;

        window.scrollTo({
            top: document.querySelector(".intro-grid").scrollTop,
            behavior: "smooth",
            duration: DURATION * 1000,
        });
        document.body.classList.add("slider-open");

        lineUpGrid();

        gsap.timeline({
            delay: 0.5,
            defaults: {
                duration: DURATION,
                ease: EASE,
            },
            onComplete: () => (isAnimating = false),
        })
            .addLabel("start", 0)
            .to(
                Object.values(gridTitle),
                {
                    yPercent: -100,
                },
                "start"
            )
            .addLabel("gridOut")
            .to(image, { filter: "brightness(100%) hue-rotate(0deg)" }, "start")
            .add(() => {
                // Save current state  of all images
                const flipstate = Flip.getState(gridImages);
                // Change layout
                introGrid.classList.add("intro-grid--slider");
                // and position the introSlider at the center of the current image
                gsap.set(introGrid, {
                    yPercent: -100 * current,
                });
                // Animate all
                Flip.from(flipstate, {
                    duration: DURATION,
                    ease: EASE,
                    absolute: true,
                    stagger: {
                        each: 0.02,
                        from: current,
                    },
                    simple: true,
                    prune: true,
                });
            }, "start")
            .set(
                sliderTitle.el,
                {
                    opacity: 1,
                },
                "start"
            )
            .fromTo(
                [sliderTitle.main, sliderTitle.desc],
                {
                    yPercent: (pos) => (pos ? 240 : 100),
                    opacity: (pos) => (pos ? 0 : 1),
                },
                {
                    yPercent: 0,
                    opacity: 1,
                },
                "start"
            )
            .add(() => {
                controls.classList.add("controls--open");
            }, "start")
            .to(".colors-container", {
                opacity: 1,
            })
            .fromTo(
                [closeCtrl, nav],
                {
                    scale: 0,
                },
                {
                    opacity: 1,
                    scale: 1,
                    stagger: 0.02,
                },
                "start"
            );
    };

    // Hide the slider
    const hideSlider = () => {
        if (isAnimating || mode === "grid") return;
        isAnimating = true;
        mode = "grid";

        const DURATION = 1;
        const EASE = "power4.inOut";

        document.body.classList.remove("slider-open");
        smoothPause(false);
        gsap.timeline({
            defaults: {
                duration: DURATION,
                ease: EASE,
                overwrite: true,
            },
            onComplete: () => (isAnimating = false),
        })
            .to(".colors-container", {
                opacity: 0,
            })
            .to(
                [closeCtrl, nav],
                {
                    opacity: 0,
                    scale: 0,
                },
                "start"
            )
            .add(() => {
                controls.classList.remove("controls--open");
            }, "start")
            .to(
                [sliderTitle.main, sliderTitle.desc],
                {
                    yPercent: (pos) => (pos ? 150 : 100),
                    opacity: (pos) => (pos ? 0 : 1),
                    onComplete: () => gsap.set(sliderTitle.el, { opacity: 0 }),
                },
                "start"
            )
            .add(() => {
                // Save current state  of all images
                const flipstate = Flip.getState(gridImages, {
                    props: "filter",
                });
                // Change layout
                introGrid.classList.remove("intro-grid--slider");
                gsap.set(gridImages[current], {
                    filter: "brightness(100%) hue-rotate(0deg)",
                });
                gsap.set(introGrid, {
                    yPercent: 0,
                });
                // Animate all
                Flip.from(flipstate, {
                    duration: DURATION,
                    ease: EASE,
                    absolute: true,
                    stagger: {
                        each: 0.02,
                        from: current,
                    },
                    simple: true,
                    prune: true,
                    onComplete: () => {
                        breakGrid();
                    },
                });
            }, "start")
            .to(
                ".intro-title .oh__inner",
                {
                    yPercent: 0,
                },
                "start"
            );
    };

    // Grid images click event
    gridImages.forEach((image) => {
        image.addEventListener("click", () => showSlider(image));

        image.addEventListener("mouseenter", () => {
            if (mode === "slider") return;
            gsap.fromTo(
                image,
                {
                    filter: "brightness(100%) hue-rotate(0deg)",
                },
                {
                    duration: 1,
                    ease: "power4",
                    filter: "brightness(150%) hue-rotate(10deg)",
                }
            );
        });

        image.addEventListener("mouseleave", () => {
            if (mode === "slider") return;
            gsap.to(image, {
                duration: 1,
                ease: "power4",
                filter: "brightness(100%) hue-rotate(0deg)",
            });
        });

        closeCtrl.addEventListener("click", () => hideSlider());
    });

    const onPrevClick = () => {
        if (current <= 0) return;
        current--;
        isAnimating = true;
        const currentImage = gridImages[current];

        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    isAnimating = false;
                }, 500);
            },
        })
            .to(introGrid, {
                duration: 1,
                ease: "power4",
                yPercent: -100 * current,
            })
            .to(
                [sliderTitle.main, sliderTitle.desc],
                {
                    duration: 0.5,
                    ease: "power4",
                    yPercent: (pos) => (pos ? 150 : 100),
                    opacity: (pos) => (pos ? 0 : 1),
                    onComplete: () => {
                        slideTextTitle.innerText = currentImage.dataset.title;
                        slideTextContent.innerText = currentImage.dataset.text;
                    },
                },
                "<"
            )
            .to([sliderTitle.main, sliderTitle.desc], {
                ease: "power4",
                yPercent: 0,
                opacity: 1,
                duration: 0.5,
            });
    };

    const onNextClick = () => {
        if (current >= gridImages.length - 1) return;
        current++;
        isAnimating = true;
        const currentImage = gridImages[current];

        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    isAnimating = false;
                }, 500);
            },
        })
            .to(
                [sliderTitle.main, sliderTitle.desc],
                {
                    duration: 0.5,
                    ease: "power4",
                    yPercent: (pos) => (pos ? 150 : 100),
                    opacity: (pos) => (pos ? 0 : 1),
                    onComplete: () => {
                        slideTextTitle.innerText = currentImage.dataset.title;
                        slideTextContent.innerText = currentImage.dataset.text;
                    },
                },
                "<"
            )
            .to([sliderTitle.main, sliderTitle.desc], {
                yPercent: 0,
                opacity: 1,
                duration: 0.5,
                ease: "power4",
            });

        gsap.to(introGrid, {
            duration: 1,
            ease: "power4",
            yPercent: -100 * current,
            onComplete: () => {
                setTimeout(() => {
                    isAnimating = false;
                }, 500);
            },
        });
    };

    const onScroll = (direction) => {
        if (direction === "down" && mode === "slider" && !isAnimating) {
            onNextClick();
        }
        if (direction === "up" && mode === "slider" && !isAnimating) {
            onPrevClick();
        }
    };

    new Observer({
        type: "wheel, touch",
        onDown: () => onScroll(ScrollTrigger.isTouch ? "up" : "down"),
        onUp: () => onScroll(ScrollTrigger.isTouch ? "down" : "up"),
    });

    // Preload images then remove loader (loading class) from body
    preloadImages(".intro-grid__img").then(() =>
        document.body.classList.remove("loading")
    );
}

function goToCollection(element) {
    var url = jQuery(element).data("url");
    barba.go(url);
}
